// extracted by mini-css-extract-plugin
export default {"wxbCon":"index_wxbCon_Nalud","wxbTxt":"index_wxbTxt_eqV8j"};